export default {
    label: 'Jak si přejete zajistit termín servisu?',
    labelSelfService: 'Děkujeme za informaci',
    text: 'Termín Vám rádi zajistíme, nebo jste si ho již domluvili sami?',
    textSelfService: 'Toto okno můžete nyní zavřít.',
    buttonOrderService: 'Objednat servis',
    buttonSelfService: 'Servis jsem si již domluvil/a'
}
